<template>
    <div class="email-template-editor">
        <div class="toolbar">
            <div class="left-buttons">
                <SupsisButton @click="$emit('close')" primary small> &lt; Geri Dön</SupsisButton>
                <SupsisButton @click="handleUpdateTemplate" primary small>
                    <i class="fas fa-save"></i> Güncelle
                </SupsisButton>
            </div>
            <div class="right-buttons">
                <SupsisButton @click="handleMjmlModalOpen">MJML</SupsisButton>
                <SupsisButton @click="handleHtmlModalOpen">HTML Göster</SupsisButton>
                <SupsisButton @click="handleModelModalOpen">Model Göster</SupsisButton>
                <TemplateSelector @template-select="handleTemplateSelect" />
            </div>
        </div>

        <div ref="editor" class="grape-wrapper"></div>

        <Modal2 v-if="mjmlModalOpen" title="MJML" @cancel="mjmlModalOpen = false">
            {{ editor && editor.getHtml() }}
        </Modal2>

        <Modal2 v-if="htmlModalOpen" title="HTML" @cancel="htmlModalOpen = false">
            {{ getRawHtml() }}
        </Modal2>

        <Modal2 v-if="modelModalOpen" title="Model" @cancel="modelModalOpen = false">
            {{ editor && JSON.stringify(editor.getComponents()) }}
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import grapesjs from "grapesjs";
import gjsPresetNewsletter from "grapesjs-preset-newsletter";
import "grapesjs/dist/css/grapes.min.css";
import gjsMjml from "grapesjs-mjml";
import mjml2html from "mjml-browser";
import TemplateSelector from "./TemplateSelector.vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { MAIL_API } from "../../../../api/mail";

export default Vue.extend({
    name: "EmailTemplateEditor",
    components: {
        TemplateSelector,
        Modal2,
        SupsisButton,
    },
    props: {
        template: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            editor: null,
            mjmlModalOpen: false,
            htmlModalOpen: false,
            modelModalOpen: false,
        };
    },
    mounted() {
        let design = this.template.design;
        if (typeof design === "string") {
            design = JSON.parse(design);
        }
        const editor = grapesjs.init({
            container: this.$refs.editor,
            plugins: [gjsPresetNewsletter, gjsMjml],
            pluginsOpts: {
                gjsPresetNewsletter: {},
                gjsMjml: {},
            },
            components: design,
            style: `
                .mj-text {
                    padding: 20px;
                }
            `,
            storageManager: false,
        });

        this.editor = editor;
        window.editor = editor;
    },
    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy();
        }
    },
    methods: {
        handleMjmlModalOpen() {
            this.mjmlModalOpen = true;
        },
        handleHtmlModalOpen() {
            this.htmlModalOpen = true;
        },
        handleModelModalOpen() {
            this.modelModalOpen = true;
        },
        handleTemplateSelect(template) {
            this.editor.setComponents(template);
        },
        getRawHtml() {
            try {
                return mjml2html(this.editor?.getHtml())?.html;
            } catch (error) {
                console.error(error);
                return "";
            }
        },
        handleUpdateTemplate() {
            const updatedHtml = this.editor.getHtml();
            const updatedDesign = this.editor.getComponents();

            const updatingFields = {
                html: updatedHtml,
                design: updatedDesign,
            };

            MAIL_API.TEMPLATE.updateEmailTemplate(this.template._id, updatingFields)
                .then((updatedTemplate) => {
                    this.$message.success("Şablon başarıyla güncellendi.");
                    this.$emit("template-updated", updatedTemplate);
                })
                .catch((error) => {
                    console.error("Şablon güncellenirken bir hata oluştu:", error);
                    this.$message.error("Şablon güncellenirken bir hata oluştu.");
                });
        },
    },
});
</script>

<style lang="scss">
.email-template-editor {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .grape-wrapper {
        height: calc(100vh - 156px) !important;
        max-height: calc(100vh - 156px) !important;
    }

    .toolbar {
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        gap: 10px;

        .left-buttons,
        .right-buttons {
            display: flex;
            gap: 10px;
        }
    }

    iframe {
        height: 100% !important;
    }
}
</style>
